import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9665cc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTravarPeriodo__SelecionarAtividade" }
const _hoisted_2 = { for: "travar-periodo" }
const _hoisted_3 = { class: "OTravarPeriodo__Conteudo" }
const _hoisted_4 = { class: "OTravarPeriodo__Projetos" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-users" }, null, -1))
const _hoisted_6 = { class: "OTravarPeriodo__TravarAte" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-clock" }, null, -1))
const _hoisted_8 = { class: "OTravarPeriodo__Footer" }

import { computed, onMounted, reactive, ref } from "vue"

  import useVuelidate from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"

  import Dialog from "primevue/dialog"
  import AButton from "primevue/button"
  import { MCalendario, MMultiSelect } from "@/components/Gerais"

  import { estados } from "@/types/api"

  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import {
    EscritorErro,
    usarEscritorDeDados,
  } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { TravarPeriodo } from "@/repositorios/travamento/travamento.modelo"
  import { TravamentosRepositorio } from "@/repositorios/travamento/travamento.repositorio"
  import { EntidadeGenerica } from "@/types/gerais"
  import { UsarLeitorDeDadosPaginados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDadosPaginados"
  import {
    ListarProjetos,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"

  /* interfaces */
  interface Props {
    visible: boolean
    destinos?: string
  }
  interface EmitirVisibilidade {
    (event: "update:visible", visible: boolean): void
    (event: "periodoTravado"): void
  }

  /* props */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTravarPeriodo',
  props: {
    visible: { type: Boolean },
    destinos: null
  },
  emits: ["update:visible", "periodoTravado"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visible", visible: boolean): void
    (event: "periodoTravado"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, destinos?: string }

  

  /* emitters */
  
  const emissorVisibilidade = computed({
    get() {
      return props.visible
    },
    set(visible: boolean) {
      emitir("update:visible", visible)
    },
  })

  const { t } = useI18n()

  /* composables */
  const { pegarDataDeHoje, pegarSomenteData } = usarDataHora()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const { colher } = usarManipuladorObjetos()
  const repositorioProjetos = new ProjetoRepositorio()
  const { escritor, resolver } = usarEscritorDeDados()
  const leitorProjetos = reactive(
    new UsarLeitorDeDadosPaginados<ListarProjetos, ParamsProjeto>(
      repositorioProjetos.listarProjetosFrontend,
      {
        "ordenar-por": ["desc.ativo", "asc.nome_projeto"],
        ativo: "igual.true",
        "por-pagina": 1000,
      }
    )
  )

  /* dados */
  const travarAte = ref<Date>(pegarDataDeHoje())
  const projetosSelecionados = ref<string[]>([])
  const projetos = ref<EntidadeGenerica[]>([])

  const regras = {
    projetosSelecionados: {
      required: helpers.withMessage(t("necessarioSelecionarPeloMenosUmaOpcao"),required),
    },
    travarAte: {
      required: helpers.withMessage(t("necessarioSelecinoarUmaData"), required),
    },
  }

  const $v = useVuelidate(regras, {
    projetosSelecionados,
    travarAte,
  })
  const estagioDaRequisicao = ref<number>(estados.INICIAL)
  const rotuloBotaoSalvar = t("confirmarTravamento")
  const estadoBotaoSalvar = computed(() => !validar() || travandoPeriodo.value)
  const travandoPeriodo = computed(
    () => estagioDaRequisicao.value === estados.PEDENTE
  )

  const travamentosRep = new TravamentosRepositorio({ utilizaCache: true })
  const travarPeriodoEscritor = escritor<{ id: string }, TravarPeriodo>(
    travamentosRep.travarPeriodo,
    []
  )

  /* métodos */
  const validar = () => {
    $v.value.$touch()
    return !$v.value.$invalid
  }

  const montarTravamentoDePeriodo = (): TravarPeriodo => {
    const travamento: TravarPeriodo = {
      projetosATravar: projetosSelecionados.value,
      dataFim: pegarSomenteData(travarAte.value),
    }
    return travamento
  }

  const fecharModal = () => {
    emissorVisibilidade.value = false
  }

  const definirEstagioDaRequisicaoComoInicial = () => {
    estagioDaRequisicao.value = estados.INICIAL
  }

  const definirEstagioDaRequisicaoComoPendente = () => {
    estagioDaRequisicao.value = estados.PEDENTE
  }

  const definirEstagioDaRequisicaoComoErro = () => {
    estagioDaRequisicao.value = estados.ERRO
  }

  const definirEstagioDaRequisicaoComoSucesso = () => {
    estagioDaRequisicao.value = estados.SUCESSO
  }

  const executarEscritorDeTravarPeriodo = async (
    travamentoDePeriodo: TravarPeriodo
  ) => {
    const darRetornoDeSucessoProUsuario = async () => {
      onSucesso({
        resumo: t("periodoTravadoComSucesso"),
        detalhes: t("todosOsProjetosSelecionadosForamTravados"),
      })
      fecharModal()
      definirEstagioDaRequisicaoComoSucesso()
      emitir("periodoTravado")
    }

    travarPeriodoEscritor.mudarArgumentos([travamentoDePeriodo])
    await travarPeriodoEscritor.executar()

    const darRetornoDeErroProUsuario = (erro: EscritorErro) => {
      onErro({
        resumo: t("erroAoTravarPeriodo"),
        detalhes: erro.mensagem,
      })

      definirEstagioDaRequisicaoComoErro()
    }

    resolver<{ id: string }>(travarPeriodoEscritor.resultado, {
      sucesso: darRetornoDeSucessoProUsuario,
      erro: darRetornoDeErroProUsuario,
    })
  }

  const travarPeriodo = async () => {
    definirEstagioDaRequisicaoComoPendente()
    const dadosEstaoValidos = validar()

    if (dadosEstaoValidos) {
      const travamentoDePeriodo = montarTravamentoDePeriodo()
      await executarEscritorDeTravarPeriodo(travamentoDePeriodo)
    }
    definirEstagioDaRequisicaoComoInicial()
  }

  const carregarDadosModoCriar = async (): Promise<void> => {
    await leitorProjetos.executar().then((resultadoLeitor) => {
      resultadoLeitor.resolver({
        sucesso: (resultado) => {
          projetos.value = colher(
            resultado,
            ["id", "nomeProjeto"],
            ["id", "nome"]
          )
        },
        erro: (erro) => {
          onErro({
            resumo: t("erroAoCarregarProjetos"),
            detalhes: erro.mensagem,
          })
        },
      })
    })
  }

  onMounted(() => {
    carregarDadosModoCriar()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emissorVisibilidade),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
    "append-to": __props.destinos,
    class: "OTravarPeriodo",
    "data-testid": "OTravarPeriodo",
    "dismissable-mask": "",
    draggable: false,
    header: "Header",
    modal: true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('travarPeriodo')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(AButton), {
          onClick: fecharModal,
          class: "OTravarPeriodo__Botao OTravarPeriodo__Submissor p-button-text p-button-danger",
          "data-testid": "OTravarPeriodo__Cancelar",
          disabled: _unref(travandoPeriodo),
          label: _unref(t)('cancelar')
        }, null, 8, ["disabled", "label"]),
        _createVNode(_unref(AButton), {
          onClick: travarPeriodo,
          class: "OTravarPeriodo__Botao p-button-success",
          "data-testid": "OTravarPeriodo__BotaoConfirmarTravamento",
          disabled: _unref(estadoBotaoSalvar),
          label: _unref(rotuloBotaoSalvar),
          loading: _unref(travandoPeriodo)
        }, null, 8, ["disabled", "label", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(MMultiSelect), {
            modelValue: _unref($v).projetosSelecionados.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref($v).projetosSelecionados.$model) = $event)),
            class: "OTravarPeriodo__SeletorProjetos",
            "data-testid": "OTravarPeriodo__SeletorProjetos",
            destino: __props.destinos,
            "exibicao-de-opcoes": "comma",
            "maximo-de-legendas-selecionadas": 2,
            "mensagem-de-erro": _unref($v).projetosSelecionados.$errors[0]?.$message,
            nome: "projetos",
            obrigatorio: "",
            "option-label": "nome",
            "option-value": "id",
            options: projetos.value,
            placeholder: _unref(t)('selecionarProjetos'),
            width: "480px"
          }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(MCalendario), {
            modelValue: _unref($v).travarAte.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).travarAte.$model) = $event)),
            id: "data-inicio",
            class: "OTravarPeriodo__SeletorTravarAte",
            "data-testid": "OTravarPeriodo__SeletorTravarAte",
            destino: __props.destinos,
            "mensagem-de-erro": _unref($v).travarAte.$errors[0]?.$message,
            rotulo: _unref(t)('travarAte')
          }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "rotulo"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "append-to"]))
}
}

})